import React from "react";
import { Box, Typography } from "@mui/material";

function ProfileOrgDetails({ user, isViewingUser = false }) {
  const getNames = (items = [], fallback) => {
    const itemNames = Array.isArray(items)
      ? items
          .map((item) => (typeof item === "object" ? item?.name : null))
          .filter(Boolean)
      : [];

    if (itemNames.length) return itemNames.join(", ");
    return fallback?.name || "N/A";
  };

  return (
    <Box flex={2} mt={isViewingUser ? 0 : 2}>
      <Typography
        variant="h5"
        fontWeight="bold"
        gutterBottom
        color="textPrimary"
      >
        Organisation Details
      </Typography>
      <Typography variant="subtitle2" color="textSecondary" gutterBottom>
        Organisation: {user?.organisation?.name}
      </Typography>
      <Typography variant="subtitle2" color="textSecondary" gutterBottom>
        Locations: {getNames(user?.locations, user?.location)}
      </Typography>
      <Typography variant="subtitle2" color="textSecondary" gutterBottom>
        Divisions: {getNames(user?.divisions, user?.division)}
      </Typography>
    </Box>
  );
}

export default ProfileOrgDetails;
